<template>
  <div class="dialog" >
    <div style="height: 300px;overflow: hidden;text-align: left"  data-scrollbar>
      <span>{{$t('cy').biga3[0]}}<br>
{{$t('cy').biga3[1]}}</span>
    </div>
  </div>
</template>

<script>
  import Scrollbar from 'smooth-scrollbar';
  export default {
    name: "aboutDia",
    mounted(){
      Scrollbar.initAll();
    }
  }
</script>

<style lang="scss" scoped>
  .dialog{
    span{
      line-height: 30px;
      text-align: left;
      font-size: 14px;
    }
  }
</style>
